module.exports = __webpack_public_path__ + "img/L_4H.16609d9c.png";